import React, { useEffect } from 'react';
import {
	Route, Routes, useLocation, useParams,
} from 'react-router-dom';

import { SlLEContext } from '../../global-constants';
import { ActionType, RequestType } from '../../global-interface';
import { LearningPathContainer } from '../LearningPathContainer/LearningPathContainer';
import { LessonContainer } from '../LessonContainer/LessonContainer';
import { SlActions } from '../../services/ActionsService/sl-actions';
import { SlDataService } from '../../services/sl-data.service';
import { TIYMaterial } from '../../components/Materials/TIY/TIYMaterial';
import { CodeCoachMaterial } from '../../components/Materials/CodeCoach/CodeCoachMaterial';
import { CodeRepoMaterial } from '../../components/Materials/CodeRepoMaterial/CodeRepoMaterial';
import { Onboarding } from '../../components/Onboarding/Onboarding';
import { useContainerData } from '../../../../shared/public/SlHooks/useContainerData';
import { LocationType, MaterialType } from '../../../../api/private/learn-engine-api/learn-engine-api.interface';
import { Container, AuthService } from '../../../../symphony';
import { RouteGuard } from '../../../../../client/Guard/RouteGuard';
import { authGuard } from '../../../../../client/Guard/AuthGuard';

export function RouteWithLearningPathContainer(): JSX.Element {
	const { pathAlias } = useParams();

	const { onboarding$: onboarding } = useContainerData(
		SlLEContext,
		SlDataService,
		['onboarding$'],
	);

	const authService = Container.take('global', AuthService);

	useEffect(() => {
		const { actions$ } = Container.take(SlLEContext, SlActions);

		const searchParams = new URLSearchParams(location.search);

		const locationUrl = +searchParams.get('location') as LocationType;

		actions$.next({
			type: ActionType.OnRouteWithLearningPathContainerMount,
			requestType: RequestType.Parallel,
			data: {
				alias: pathAlias,
				locationUrl,
			},
		});
	}, [pathAlias, authService.isLoggedIn()]);

	const { pathname } = useLocation();

	return (
		<div>
			{onboarding ? (
				<Onboarding />
			) : (
				<Routes>
					<Route
						path="/"
						element={(
							<LearningPathContainer
								key={pathname?.split('/').at(-1)}
							/>
						)}
					/>
					<Route
						path="lesson/:materialId/*"
						element={<LessonContainer />}
					/>
					<Route
						path="code-repo/:materialId/*"
						element={(
							<RouteGuard
								component={<CodeRepoMaterial />}
								guards={[
									authGuard({
										guardType: 'onlyAuthorized',
										navigationType: 'internal',
										redirectUrl: '/users/login',
									}),
								]}
							/>
						)}
					/>
					<Route
						path="code-coach/:materialId/*"
						element={(
							<RouteGuard
								component={<CodeCoachMaterial />}
								guards={[
									authGuard({
										guardType: 'onlyAuthorized',
										navigationType: 'internal',
										redirectUrl: '/users/login',
									}),
								]}
							/>
						)}
					/>
					<Route
						path="code-project/:materialId/*"
						element={(
							<RouteGuard
								component={<CodeCoachMaterial type={MaterialType.CodeProject} />}
								guards={[
									authGuard({
										guardType: 'onlyAuthorized',
										navigationType: 'internal',
										redirectUrl: '/users/login',
									}),
								]}
							/>
						)}
					/>
					<Route
						path="tiy/:materialId/*"
						element={(
							<RouteGuard
								component={<TIYMaterial />}
								guards={[
									authGuard({
										guardType: 'onlyAuthorized',
										navigationType: 'internal',
										redirectUrl: '/users/login',
									}),
								]}
							/>
						)}
					/>
				</Routes>
			)}
		</div>
	);
}
